import find from "lodash/find";
import {ChatMessage, PaginatedChatMessages} from "src/types/generated";

import {getChatConversationMessagesQuery} from "../../../widgets/modules/Chat/queries/getChatConversationMessagesQuery";
import {createApolloConversationMessage} from "./createApolloConversationMessage";

export function writeConversationMessageToApolloCache(message: ChatMessage, client, variables) {
    const apolloMessageData = createApolloConversationMessage(message);
    const {
        getChatConversationMessages: messagesCache,
    }: {getChatConversationMessages: PaginatedChatMessages} = client.readQuery({
        query: getChatConversationMessagesQuery,
        variables,
    });

    // filter out optimistic msg since socket message could arrive
    // before the mutation result has removed the optimistic messages
    // this seems like an edge case
    const filteredMessages = messagesCache.messages.filter((m) => !m.id.startsWith("optimistic-"));

    // ignore message which are already in the store (sent by me)
    const messageExists = find(filteredMessages, {id: apolloMessageData.id});

    if (!messageExists) {
        const newMessages = [...filteredMessages, apolloMessageData];

        // Add our message from the websocket to the end.
        // data.getChatConversationMessages.messages.push(apolloMessageData);
        // Write our data back to the cache.
        client.writeQuery({
            query: getChatConversationMessagesQuery,
            variables,
            data: {
                getChatConversationMessages: {
                    ...messagesCache,
                    messages: newMessages,
                },
            },
        });
    }
}
